import Link from "next/link";
import React, { ChangeEvent, useState } from "react";
import { Table, Container, Row, Col, FormGroup, Input } from "reactstrap";
import useApi from "~/hooks/use-api";
import { LinkExternalIcon } from "@primer/octicons-react";
import GlobalAuthHeader from "~/components/GlobalAuthHeader";
import { Restricted } from "~/components/Restricted";

export interface Client {
  id: string;
  owner: string;
  isProdReady: boolean;
  secret: string;
  name: string;
  url: string;
  templateUrl: string;
  redirectUrls: string | Array<string>;
}

export default function ClientPage(): JSX.Element {
  const { data: clients } = useApi<Client[]>("/api/global-auth-clients");

  return (
    <>
      <GlobalAuthHeader active="clients" />
      <Container>
        <ClientDetails data={clients} />
      </Container>
    </>
  );
}

function ClientDetails({ data }: { data: Client[] | null }) {
  const [filterClient, setFilterClient] = useState("");
  const handleFilterUser = (event: ChangeEvent<HTMLInputElement>) => {
    setFilterClient(event.target.value.toLocaleLowerCase());
  };

  const { data: authBaseUrl } = useApi<string>("/api/config/auth-url");

  return (
    <>
      <Row>
        <Col sm={"5"}>
          <FormGroup>
            <Input
              type="search"
              placeholder="Find Client"
              onChange={handleFilterUser}
              autoFocus={true}
            />
          </FormGroup>
        </Col>
        <Restricted require="privileged">
          <Col sm={"3"}>
            <Link href="/global-auth/clients/new" passHref>
              <a className="btn btn-primary">Add Client</a>
            </Link>
          </Col>
        </Restricted>
      </Row>
      <Table>
        <thead>
          <tr>
            <th>Client</th>
            <th>URL</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data
              .filter((c) => c.name.toLocaleLowerCase().includes(filterClient))
              .map((item: Client) => {
                return (
                  <tr key={item.id}>
                    <td>
                      <Link href={`/global-auth/clients/${item.id}`}>
                        <a>{item.name} </a>
                      </Link>
                      <small>{item.id}</small>
                    </td>
                    <td>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={`${authBaseUrl}/install-client?client=${item.id}`}
                      >
                        Install <LinkExternalIcon size={"small"} />
                      </a>{" "}
                      <Link href={item.url} passHref>
                        <a target="_blank" rel="noreferrer">
                          Homepage <LinkExternalIcon size={"small"} />
                        </a>
                      </Link>
                    </td>
                  </tr>
                );
              })}
        </tbody>
      </Table>
    </>
  );
}
